export function formatCount(count: number): number | string {
  return count < 10000 ? count : `${Math.floor(count / 1000) / 10}万`;
}

export function formatNumberEn(num: number, lowerCase?: boolean) {
  const unit = {
    k: lowerCase ? 'k' : 'K',
    m: lowerCase ? 'm' : 'M',
    b: lowerCase ? 'b' : 'B',
  };
  if (!num || isNaN(num) || typeof num !== 'number') {
    return '0';
  }

  if (num < 0) {
    // eslint-disable-next-line @ies/eden/max-calls-in-template
    return `-${formatNumberEn(Math.abs(num))}`;
  }
  if (num < 1e3) {
    return `${num}`;
  }

  num = num || 0;
  const k = num < 1e6;
  const m = num >= 1e6 && num < 1e9;

  const numDigits = `${num / (k ? 1e3 : m ? 1e6 : 1e9)}`.split('.');
  const integer = numDigits[0] || 0;
  const float = (numDigits[1] || '0').slice(0, 1);

  return `${integer}${float !== '0' ? `.${float}` : ''}${k ? unit.k : m ? unit.m : unit.b}`;
}

export const getQueryString = function (name: string, noDecode?: boolean): string | null {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return noDecode ? r[2] : decodeURIComponent(r[2]);
  }
  return null;
};

export function safeGet(data: any, path: string, defaultValue?: any) {
  try {
    if (!path) {
      return defaultValue;
    }
    const paths = path.split('.');
    let res = data;
    while (paths.length) {
      res = res[paths.shift()];
      if (res === undefined) {
        return defaultValue;
      }
    }
    return res;
  } catch (error) {
    return defaultValue;
  }
}

export function formatTime(time: number) {
  const second = Math.floor(time / 1000000);
  return `${Math.floor(second / 60)
    .toString()
    .padStart(2, '0')} : ${(second % 60).toString().padStart(2, '0')}`;
}

export function formatDuration(length: number) {
  const duration = length / 1000;
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration - hours * 3600) / 60);
  const seconds = Math.ceil(duration - hours * 3600 - minutes * 60);

  return `${hours ? `${hours}:` : ''}${minutes >= 10 ? minutes : `0${minutes}`}:${`00${seconds}`.slice(-2)}`;
}

export function formatAmount(count: number) {
  const res = (count || 0).toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => `${$1},`);
  });
  return res;
}

export function formatPercent(num: number, digit = 1): string {
  if (typeof num !== 'number' || isNaN(num)) {
    return `${(0).toFixed(digit)}%`;
  }
  return `${(num * 100).toFixed(digit)}%`;
}
